import { render, staticRenderFns } from "./Call24Page.vue?vue&type=template&id=2ee1e9cc"
import script from "./Call24Page.vue?vue&type=script&lang=js"
export * from "./Call24Page.vue?vue&type=script&lang=js"
import style0 from "./Call24Page.vue?vue&type=style&index=0&id=2ee1e9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports